import React from 'react'
import { Box, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import LegendItem, { LegendItemProps } from 'src/Libs/chart-kit/shared/components/LegendItem'

const useStyles = makeStyles<{ color?: string; type?: 'vertical' | 'horizontal' }>()((theme, { color, type }) => ({
  tooltipItemWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    gap: theme.spacing(2),
    whiteSpace: 'nowrap',
    alignItems: 'center',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
    },
  },
  valuesWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
  },
  value2: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100px',
    [theme.breakpoints.down('sm')]: {
      width: '40%',
    },
  },
  value1: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '130px',
    [theme.breakpoints.down('sm')]: {
      width: '60%',
    },
  },
}))

const TooltipItem = ({
  color,
  title,
  value1,
  value2,
  type = 'bar',
}: {
  color: string
  title: string
  value1?: string
  value2?: string
  type?: LegendItemProps['type']
}): JSX.Element => {
  const { classes } = useStyles({ color })

  return (
    <Box className={classes.tooltipItemWrapper}>
      <LegendItem type={type} title={title} color={color} />

      <Box className={classes.valuesWrapper}>
        {value1 && (
          <Typography className={classes.value1} variant="subtitle1" fontWeight="normal">
            {value1}
          </Typography>
        )}
        {value2 && (
          <Typography className={classes.value2} variant="subtitle1">
            {value2}
          </Typography>
        )}
      </Box>
    </Box>
  )
}

export default TooltipItem
